const green: Record<string, string> = {
  50: '#f4fbf4',
  100: '#e4f6e4',
  200: '#c2efc2',
  300: '#89e689',
  400: '#36e236',
  500: '#0dca0d',
  600: '#04a404',
  700: '#008000',
  800: '#006600',
  900: '#004d00',
  950: '#002900',
  DEFAULT: '#008000',
};

export default green;
